<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <span class="title_before side_title">盘点单</span>
    </div>
    <div style="padding:0px 20px 0px 24px">
      <div
        class="flex_between_nowrap"
        style="margin-top:20px;margin-bottom:30px"
      >
        <div>
          <el-input
            clearable
            placeholder="请输入盘点单名称"
            size="small"
            v-model="params['search']"
            style="width:300px;"
          >
            <i
              slot="suffix"
              class="el-icon-search inputIcon "
              @click.stop="tableSearch"
            ></i>
          </el-input>
        </div>
        <div class="flex_end">
          <el-button
            type="main"
            icon="iconfont icon-a-Advancedsearch Advancedsearch"
            style="width:120px;margin-right:10px"
            @click="moveSearch"
            >高级搜索</el-button
          >

          <el-button type="submit" @click="add_click">新增盘点</el-button>
        </div>
      </div>
      <x-table
        url="/pc/check/page"
        ref="xTable"
        :axiosType="true"
        :params="params"
        @row-click="table_row_click"

        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
        >
          <template slot-scope="scope">
            <el-tag
              :style="checkStatusFulter(scope.row[item.model], false)"
              v-if="item.model == 'checkStatus'"
              >{{ checkStatusFulter(scope.row[item.model], true) }}</el-tag
            >
            <el-tag
              :style="checkResultFulter(scope.row[item.model], false)"
              v-else-if="item.model == 'checkResult'"
              >{{ checkResultFulter(scope.row[item.model], true) }}</el-tag
            >
            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="操作"
          fixed="right"
          width="240px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              class="addColor"
              @click="details_click(scope.row.id)"
              >盘点任务详情</el-button
            >
            <el-button
              type="text"
              class="addColor"
              @click="
                $router.push({
                  path: `/pd/gainorloss`,
                  query: { id: scope.row.id },
                })
              "
              >损益处理</el-button
            >
            <el-button
              type="text"
              @click="
                $axiosDelete(
                  '/pc/check/del',
                  { id: scope.row.id },
                  tableSearch,
                  '',
                  true
                )
              "
              class="deleteColor"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </x-table>
    </div>
    <!-- 高级搜索 -->
    <el-drawer
      append-to-body
      title="高级搜索"
      size="360px"
      modal
      :visible.sync="moveDrawer"
      :before-close="closeDeawer"
      direction="rtl"
    >
    <div class="x-drawer-append-body">
      <div class="x-drawer-append-main">
        <el-form
          class="elFormClass"
          :model="params"
          ref="ruleForm"
          label-width="auto"
          size="small"
        >
          <el-form-item
            v-for="(item, index) in searchItems"
            :label="item.label"
            :key="index"
          >
            <el-select
              clearable
              v-if="item.model == 'checkResult' || item.model == 'checkStatus'"
              style="width:100%"
              v-model="params[item.model]"
              :placeholder="`请选择` + item.label"
            >
              <el-option
                v-for="(s, si) in item.options"
                :key="si"
                :label="s.label"
                :value="s.model"
              >
              </el-option>
            </el-select>
            <!-- <x-select
              v-else-if="item.model == 'createBy'"
              :placeholder="'请选择' + item.label"
              ref="area"
              style="flex:1;"
              :label="item.optionslabel"
              :model="item.optionsmodel"
              v-model="params[item.model]"
              :url="item.url"
              :params="item.params"
            ></x-select> -->
            <el-input
              @focus="assetAdminFocus"
              clearable
              @clear="assetAdminclear"
              v-else-if="item.model == 'createByName'"
              :placeholder="'请选择' + item.label"
              v-model="params[item.model]"
            ></el-input>
            <el-date-picker
              clearable
              v-else-if="item.label == '时间范围'"
              v-model="pickerArr"
              @change="pickerChange"
              style="width:100%"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
     
      </div>
      <div class="dialog_bottom">
          <el-button
            class="dialog_close"
            size="small"
            type="main"
            @click="close"
            >取 消</el-button
          >
          <el-button
            class="dialog_submit"
            size="small"
            style="width:100px"
            type="submit"
            @click="submit"
            >查 询</el-button
          >
        </div>
    </div>
      
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pickerArr: [],
      searchItems: [
        {
          label: "盘点结果",
          model: "checkResult",
          options: [
            {
              label: "不限",
              model: null,
            },
            {
              label: "未盘",
              model: "not",
              style: "color:#436bff;background:#d8e6ff;",
            },
            {
              label: "盘亏",
              model: "little",
              style: "color:#fa675c;background:#ffd0cc;",
            },
            {
              label: "正常",
              model: "normal",
              style: "color:#42b983;background:#f0f9eb;",
            },
            {
              label: "盘盈",
              model: "more",
              style: "color:#ffa200;background:#ffefd8;",
            },
          ],
        },
        {
          label: "盘点状态",
          model: "checkStatus",
          options: [
            {
              label: "不限",
              model: null,
            },
            {
              label: "盘点中",
              model: "await",
              style: "color:#436bff;background:#d8e6ff;",
            },
            {
              label: "等待审核",
              model: "examine",
              style: "color:#ffa200;background:#ffefd8;",
            },
            {
              label: "完成",
              model: "end",
              style: "color:#42b983;background:#f0f9eb;",
            },
          ],
        },

        {
          label: "创建人",
          model: "createByName",
          optionslabel: "staffName",
          optionsmodel: "id",
          url: "/pc/admin/page",
          params: { type: "all" },
        },

        {
          label: "时间范围",
        },
      ],

      moveDrawer: false,
      params: {
        checkResult: null,
        checkStatus: null,
      },
      defaultParams: {
        checkResult: null,
        checkStatus: null,
      },
      columnArr: [
        {
          label: "盘点状态",
          model: "checkStatus",
        },
        {
          label: "盘点结果",
          model: "checkResult",
        },
        {
          label: "盘点标题",
          model: "checkTitle",
        },
        {
          label: "应盘任务",
          model: "shouldCount",
        },
        {
          label: "实盘任务",
          model: "actualCount",
        },
        {
          label: "应盘资产",
          model: "shouldGoodsCount",
        },

        {
          label: "实盘资产",
          model: "actualGoodsCount",
        },
        {
          label: "盘点备注",
          model: "remark",
        },
        {
          label: "审批人",
          model: "recheckName",
        },
        {
          label: "创建人",
          model: "createName",
        },
        {
          label: "创建时间",
          model: "createTime",
        },
      ],
    };
  },
  mounted() {},
  methods: {
    assetAdminCallBack(data) {
      if (data.id) {
        this.$set(this.params, "createByName", data.staffName);
        this.$set(this.params, "createBy", data.id);
      }
    },
    assetAdminclear() {
      this.$set(this.params, "createByName", "");
      this.$set(this.params, "createBy", "");
    },
    assetAdminFocus() {
      this.$createDialog(this, {
        dialogConfig: { title: "选择人员", width: "50%" },
        namespace: "select_account",
        whetherDestruction: true,

        assemblyConfig: {
          queryType: "all",
          callBack: this.assetAdminCallBack,
        },
      });
    },
    details_click(id) {
      this.$createDialog(this, {
        dialogConfig: { title: "盘点详情", width: "860px" },
        namespace: "pd_task_details",
        whetherDestruction: true,

        assemblyConfig: {
          id,
          callBack: this.tableSearch,
        },
      });
    },
    table_row_click(row){
  /* 

        @row-click="table_row_click"
   */
this.$refs.xTable.set_checket(row)
},
    checkResultFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.searchItems[0].options.length; i++) {
        if (this.searchItems[0].options[i].model == data) {
          a = flag
            ? this.searchItems[0].options[i].label
            : this.searchItems[0].options[i].style;
          break;
        }
      }
      return a;
    },
    checkStatusFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.searchItems[1].options.length; i++) {
        if (this.searchItems[1].options[i].model == data) {
          a = flag
            ? this.searchItems[1].options[i].label
            : this.searchItems[1].options[i].style;
          break;
        }
      }
      return a;
    },
    handleSelectionChange(data) {
      this.selectArr = data;
    },
    add_click() {
      this.$createDialog(this, {
        dialogConfig: { title: "盘点新增", width: "860px" },
        namespace: "pd_task_add",
        whetherDestruction: true,

        assemblyConfig: {
          callBack: this.tableSearch,
        },
      });
    },
    submit() {
      this.$refs.xTable.formParams.current = 1;

      this.defaultParams = this.params;
      this.moveDrawer = !this.moveDrawer;
      this.tableSearch();
    },
    close() {
      let flag = false;
      for (let key in this.params) {
        if (this.params[key]) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$alertMsg.confirm(`您将丢失未保存的内容,确定继续吗`, () => {
          this.params = JSON.parse(JSON.stringify(this.defaultParams));
          this.moveDrawer = !this.moveDrawer;
    setTimeout(()=>{
        this.tableSearch();
    })
return

        });
      } else {
        this.moveDrawer = !this.moveDrawer;
       setTimeout(()=>{
        this.tableSearch();
    })
return
      }
    },
    closeDeawer(done) {
      let flag = false;
      for (let key in this.params) {
        if (this.params[key]) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$alertMsg.confirm(`您将丢失未保存的内容,确定继续吗`, () => {
                  this.params = JSON.parse(JSON.stringify(this.defaultParams));

          done();
              setTimeout(()=>{
        this.tableSearch();
    })
return
        });
      } else {
        done();
            setTimeout(()=>{
        this.tableSearch();
    })
return
      }
    },
    pickerChange(data) {
      if (data) {
        this.params.minTime = data[0];
        this.params.maxTime = data[1];
      } else {
        this.params.minTime = "";
        this.params.maxTime = "";
      }
    },

    moveSearch() {
      this.moveDrawer = !this.moveDrawer;
    },

    tableSearch() {
      this.$refs.xTable.search();
    },
  },
};
</script>
<style scoped lang="less">
.x-drawer-append-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  box-sizing: border-box;
  height: 100%;
  .x-drawer-append-main {
    padding: 8px 30px 22px 30px;
    box-sizing: border-box;
    overflow: auto;
    flex: 1;

  }
  .dialog_bottom {
    width: 100%;
    flex-shrink: 0;
    height: 80px;
    padding-right: 30px;
    border-top: 1px solid #e0e0e0;
    box-sizing: border-box;

  }
}
</style>
